import { Transformer } from '@is24at/react-transformers';
import {
  cwid,
  companyName,
  phone,
  mobile,
  features,
  addressLines,
  logoUrl,
  exposePath,
} from 'core/transformers';
import { byImageResizeUrl } from 'selectors';

const resultListTransformer = (expose, state) => ({
  raw: expose,

  view: new Transformer({
    cwid,
    companyName,
    addressLines,
    phone,
    mobile,
    features,
    exposePath,
    logoUrl: (exposeArg) => logoUrl(exposeArg, byImageResizeUrl(state)),
  }).transform(expose),
});

export default resultListTransformer;
